import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

export function AccountLimitsSection() {
  return (
    <Card data-testid="account-limits-card">
      <CardHeader>
        <CardTitle className="font-heading">Limites du compte</CardTitle>
        <CardDescription>Les limites de votre plan actuel</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-between p-4 bg-muted/50 rounded-lg">
            <div>
              <p className="font-medium">Membres d'équipe</p>
              <p className="text-sm text-muted-foreground">Nombre maximum d'utilisateurs</p>
            </div>
            <span className="text-2xl font-heading font-bold">10</span>
          </div>
          <div className="flex items-center justify-between p-4 bg-muted/50 rounded-lg">
            <div>
              <p className="font-medium">Clones digitaux</p>
              <p className="text-sm text-muted-foreground">Nombre maximum de clones</p>
            </div>
            <span className="text-2xl font-heading font-bold">5</span>
          </div>
        </div>
        <p className="text-sm text-muted-foreground mt-4">
          Besoin de plus ? Contactez-nous pour mettre à niveau votre plan.
        </p>
      </CardContent>
    </Card>
  );
}
